/* eslint complexity: off */

import { history as historyRouter } from 'instantsearch.js/es/lib/routers';
import type { UiState } from 'instantsearch.js';

type RouteState = {
  name?: string;
  page?: string;
};

const routeStateDefaultValues: RouteState = {
  name: '',
  page: '1',
};

const router = historyRouter<RouteState>({

  createURL({ qsModule, routeState, location }): string {
    const { protocol, hostname, port = '', pathname, hash } = location;
    const portWithPrefix = port === '' ? '' : `:${port}`;
    const baseUrl = `${protocol}//${hostname}${portWithPrefix}${pathname}`;

    const queryParameters: Partial<RouteState> = {};
    if (
      routeState.name &&
      routeState.name !== routeStateDefaultValues.name
    ) {
      queryParameters.name = encodeURIComponent(routeState.name);
    }
    if (routeState.page && routeState.page !== routeStateDefaultValues.page) {
      queryParameters.page = routeState.page;
    }
    
    const queryString = qsModule.stringify(queryParameters, {
      addQueryPrefix: true,
      arrayFormat: 'repeat',
    });

    return `${baseUrl}${queryString}${hash}`;
  },

  parseURL({ qsModule, location }): RouteState {
    const queryParameters = qsModule.parse(location.search.slice(1));
    const {
      name = '',
      page = 1,
    } = queryParameters;
  
    return {
      name: decodeURIComponent(name as string),
      page: page as string,
    };
  },
});

const getStateMapping = ({ indexName }: { indexName: string}) => ({
  stateToRoute(uiState: UiState): RouteState {
    const indexUiState = uiState[indexName];
    return {
      name: indexUiState.query,
      page: (indexUiState.page && String(indexUiState.page)) || undefined,
    };
  },

  routeToState(routeState: RouteState): UiState {
  
      return {
        [indexName]: {
          query: routeState.name,
          page: Number(routeState.page),
        }
      };
   
  },
});

const getRouting = (indexName: string) => ({
  router,
  stateMapping: getStateMapping({ indexName }),
});

export default getRouting;


